import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FlatpickrDirective, provideFlatpickrDefaults } from 'angularx-flatpickr';
import { getFlatpickrDefaults } from '../flatpickr-defaults';

@Component({
  selector: 'app-date',
  imports: [FlatpickrDirective,CommonModule,FormsModule],
  templateUrl: './date.component.html',
  styleUrl: './date.component.scss',
    providers: [
    provideFlatpickrDefaults(getFlatpickrDefaults())
  ],
})
export class DateComponent implements OnChanges, OnInit {
  @Input() header: string = '';
  @Input() id: string = '';
  @Input() keyRequired: boolean = false;
  @Input() checkValidation: boolean = false;
  @Input() existingValue: string | Date | null = null;
  @Input() icon: boolean | string = false;
  @Input() iconName: string = '';

  get hasIcon(): boolean {
    return !!(this.icon === true ||
              (typeof this.icon === 'string' && this.icon.trim() !== '' && this.icon !== 'false') ||
              this.iconName);
  }

  get resolvedIconClass(): string {
    const ic = (typeof this.icon === 'string' && this.icon !== 'true' && this.icon !== 'false'
      ? this.icon
      : this.iconName || '').trim();
    if (!ic) return 'fa fa-calendar';
    if (ic.startsWith('fa-') && !ic.includes(' ')) return `fa ${ic}`;
    return ic;
  }
today = new Date();

  @Output() selecteditem = new EventEmitter<{ id: string; value: string }>();
  @Output() requiredKey = new EventEmitter<{ id: string; required: boolean }>();

  public selectedDate: string | Date = '';
  public formattedDate: string = '';
  public showRequiredError: boolean = false;

  ngOnInit(): void {
    // ✅ If existing value is provided, set it up
    if (this.existingValue) {
      this.setDateFromExisting(this.existingValue);
    }

    if (this.keyRequired === true) {
      setTimeout(() => {
        this.requiredKey.emit({ id: this.id, required: this.keyRequired });
      }, 300);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // ✅ Handle updates to existingValue after init as well
    if (changes['existingValue'] && changes['existingValue'].currentValue) {
      this.setDateFromExisting(changes['existingValue'].currentValue);
    }

    if (this.checkValidation === true && !this.formattedDate) {
      this.showRequiredError = true;
    }
  }

  private setDateFromExisting(value: string | Date) {
    const date = new Date(value);
    if (!isNaN(date.getTime())) {
      this.selectedDate = date;
      this.formattedDate = date.toISOString().split('T')[0];
    }
  }

  updateFormattedDate(): void {
    if (this.selectedDate) {
      const date = new Date(this.selectedDate);

      if (!isNaN(date.getTime())) {
        this.formattedDate = date.toISOString().split('T')[0];
        this.showRequiredError = false;
        this.selecteditem.emit({ id: this.id, value: this.formattedDate });
      } else {
        this.formattedDate = '';
        this.showRequiredError = true;
      }
    } else {
      this.formattedDate = '';
    }
  }
}

